import type { ComponentProps } from 'react';
import { cn, DrawerContent as HeritageDrawerContent } from '@herit-fe/heritage-ui';

/**
 * 중첩 드로워 recede(뒤로 밀림) — 자식 드로워가 열리면 부모가 깊이만큼 축소돼 "뒤 카드"로 물러난다.
 * base-ui 가 부모 팝업에 뿌리는 `data-nested-drawer-open` + `--nested-drawers`(열린 자식 수)를 소비할 뿐,
 * 상태 계산은 전부 base-ui 소유다(우리는 표현만).
 *
 * ⚠️ **transform 합성 필수** — heritage `DrawerContent` 는 스와이프 추종을 `transform:translateY(var(--drawer-swipe-movement-y))`
 * 로 이미 쓰고 있다. scale 을 따로 선언하면 둘 중 하나가 통째로 덮여 드래그가 죽거나 축소가 안 먹는다.
 * 그래서 **이동량 + 축소를 한 transform 값**으로 합치고, variant 2개(`data-[swipe-direction]` +
 * `data-[nested-drawer-open]`)로 heritage 규칙보다 높은 specificity 를 확보한다.
 *
 * `origin-bottom` = 바닥 고정 — bottom 드로워를 중앙 기준으로 줄이면 화면 하단에 틈이 생긴다. 바닥을 붙박아
 * 두면 상단 모서리만 내려가 iOS 스택 시트처럼 읽힌다. 축소량(깊이당 4%)은 이 상수 한 줄이 SSOT.
 *
 * bottom(=non-pc)만 다룬다 — pc 의 right 드로워는 그 안 `SelectField` 가 팝오버라 중첩이 생기지 않는다.
 */
const NESTED_RECEDE = [
  'border-none bg-card data-[swipe-direction=down]:data-[nested-drawer-open]:origin-bottom',
  'data-[swipe-direction=down]:data-[nested-drawer-open]:[transform:translateY(var(--drawer-swipe-movement-y,0px))_scale(calc(1_-_0.04_*_var(--nested-drawers,0)))]',
  'data-[swipe-direction=down]:data-[nested-drawer-open]:brightness-95',
  'data-[swipe-direction=down]:data-[nested-drawer-open]:blur-[1px]',
].join(' ');

/**
 * 공용 DrawerContent — heritage `DrawerContent` + heviton 중첩 정책. 외부 npm 이라 직접 수정 불가 →
 * wrapper 로 className 보강(`ScrollArea`·`RadioGroupItem` 과 동일 전략). barrel 이 heritage 원본 대신 이걸
 * 내보내므로 앱의 모든 드로워가 같은 중첩 거동을 갖는다. `className` 은 정책 **뒤**에 병합돼 override 가능.
 */
export function DrawerContent({
  className,
  ...props
}: ComponentProps<typeof HeritageDrawerContent>) {
  return <HeritageDrawerContent className={cn(NESTED_RECEDE, className)} {...props} />;
}
